let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8iU4E")).then(() => parcelRequire('46IN4'));